<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Mietvertrag Management

  section.modal-card-body
    ValidationObserver(ref="form")
      .generic-wrapper
        .container
          .two-column
            .column
              h2.title.is-6 E-Mail Anhang
              iframe(ref="pdf-preview").pdf-preview
            .column
              .form.w640
                h2.title.is-6 E-Mail schreiben
                ValidationProvider(name="E-Mail Betreff" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Betreff" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    b-input(v-model="formData.subject")
                ValidationProvider(name="E-Mail Text" rules="required" v-slot="{ errors, valid }") 
                  b-field(label="E-Mail Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="formData.body" :editorOptions="editorOptions")
              .spacer.sm
              .form.w640
                h2.title.is-6 Stornierungs-PDF verändern
                ValidationProvider(name="Optionaler Guthaben Text" rules="" v-slot="{ errors, valid }") 
                  b-field(label="Optionaler Guthaben Text" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                    vue-editor(v-model="htmlFundsAvailableText" :editorOptions="minimalEditorOptions")
                h2.title.is-6 Kulanz Möglichkeiten
                b-field(grouped)
                  ValidationProvider(name="Tage Kulanz" rules="" v-slot="{ errors, valid }") 
                    b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                      b-checkbox(v-model="formData.goodwillDays" expanded) Mietpreis 0€
                  .spacer.md
                  ValidationProvider(name="Gebühr Kulanz" rules="" v-slot="{ errors, valid }") 
                    b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                      b-checkbox(v-model="formData.goodwillFee" expanded) Stornierungsgebühr 0€
                  .spacer.md
                  ValidationProvider(name="Extra Kulanz" rules="" v-slot="{ errors, valid }") 
                    b-field(:type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                      b-checkbox(v-model="formData.goodwillItems" expanded) Buchungsextras 0€
                b-button(type="is-light" @click="generatePDF()") PDF aktualisieren

      
  footer.modal-card-foot
    button.button.is-light(@click="$emit('close')") Abbrechen
    button.button.is-secondary(@click="sendCancelInvoice()") Speichern ohne Senden
    button.button.is-primary(@click="sendCancelInvoice('sendEmail')") Senden & Speichern
</template>

<script>
import { DateTime } from "luxon";
import htmlToPdfmake from "html-to-pdfmake";

export default {
  props: {
    booking: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      htmlFundsAvailableText: '',
      formData: {
        subject: 'Unser Angebot zu Ihrer Anfrage - '+this.booking.rentObject.name,
        body: null,
        pdfmakeFundsAvailableText: null,
        goodwillDays: false,
        goodwillItems: false,
        goodwillFee: false
      },
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"] // remove formatting button
          ]
        }
      },
      minimalEditorOptions: {
        placeholder: "Bei Guthaben können Sie hier einen alternativen Text eintragen ...",
        theme: "snow",
        focus: false,
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  watch: {
    htmlFundsAvailableText: {
      deep: true,
      handler() {
        this.throttleUpdate();
      }
    }
  },
  async mounted() {
    this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
    const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
    let contractTemplate = emailTemplates.find(e => e.uuid === 'CANCEL_INVOICE_EMAIL');
    const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: contractTemplate, booking: this.fullBooking});
    this.formData.subject = result.template.subject;
    this.formData.body = result.template.body;
    this.generatePDF();
  },
  methods: {
    throttleUpdate () { // We return a throttled function
      if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
        this.convertHtmlToPdfmake();
      }, 300);
    },
    convertHtmlToPdfmake() {
      this.formData.pdfmakeFundsAvailableText = htmlToPdfmake(this.htmlFundsAvailableText, {defaultStyles:{p: ''}});
    },
    async generatePDF() {
      const loadingComponent = this.$buefy.loading.open();
      
      const pdfArraybuffer = await this.$store.dispatch("rentObjectBookings/cancelInvoicePDFPreview", {id: this.booking.id, ...this.formData});
      const pdfBlob = new Blob([pdfArraybuffer], { type: "application/pdf" });
      this.$refs["pdf-preview"].src = URL.createObjectURL(pdfBlob);
      
      loadingComponent.close();
    },
    sendCancelInvoice(sendEmail) {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          return;
        }

        const loadingComponent = this.$buefy.loading.open();
        const b = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
        await this.$store.dispatch("cancelInvoices/create", {...this.formData, rentObjectBookingId: this.booking.id, contractId: b.parentContractId, sendEmail});
        loadingComponent.close();
        
        this.fullBooking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.booking.id});
        this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.booking.startDate).toHTTP(), jumpObjectId: this.fullBooking.rentObjectId, bookingStatusId: this.fullBooking.bookingStatusId}});
        this.$emit('refreshInbox');
        this.$emit('close');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.two-column {
  display: flex;
  justify-content: space-between;
}

.pdf-preview {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 280px);
}
</style>